import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import Card from './Card';

interface ContactItemProps {
  label: string;
  value: string;
  href: string;
  external?: boolean;
}

const ContactItem: React.FC<ContactItemProps> = ({ label, value, href, external = true }) => (
  <a
    href={href}
    target={external ? '_blank' : undefined}
    rel={external ? 'noopener noreferrer' : undefined}
    className="group grid grid-cols-[110px_1fr_auto] items-center gap-4 py-4 border-b border-neutral-200 dark:border-neutral-800 hover:bg-neutral-200/40 dark:hover:bg-neutral-900/40 transition-colors px-2 -mx-2"
  >
    <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-neutral-500 dark:text-neutral-500">
      {label}
    </span>
    <span className="font-mono text-sm text-neutral-900 dark:text-neutral-100 truncate">
      {value}
    </span>
    <ArrowUpRight
      size={14}
      className="text-neutral-400 dark:text-neutral-600 group-hover:text-accent group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
    />
  </a>
);

const ContactSection: React.FC = () => {
  return (
    <Card title="Contact" index={5}>
      <p className="text-base leading-relaxed text-neutral-600 dark:text-neutral-400 mb-8 max-w-xl">
        Always open to interesting projects, full-stack roles, and conversations about payment systems or enterprise frontend work. Reach out through any of these channels.
      </p>
      <div className="border-t border-neutral-200 dark:border-neutral-800">
        <ContactItem
          label="Email"
          value="bugraozdilek@gmail.com"
          href="mailto:bugraozdilek@gmail.com"
          external={false}
        />
        <ContactItem
          label="LinkedIn"
          value="bugra-ozdilek123"
          href="https://www.linkedin.com/in/bugra-ozdilek123/"
        />
        <ContactItem
          label="GitHub"
          value="bugraOzd"
          href="https://github.com/bugraOzd"
        />
        <ContactItem
          label="Location"
          value="Türkiye"
          href="https://www.google.com/maps/place/Turkey"
        />
      </div>
      <motion.div
        className="mt-10 flex items-center justify-between gap-6 flex-wrap"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.3 }}
      >
        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-neutral-500 dark:text-neutral-500">
          Prefer a call? Book a slot directly.
        </p>
        <a
          href="https://calendly.com/bugraozdilek"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent hover:bg-accent-hover text-neutral-950 font-mono text-[11px] uppercase tracking-[0.14em] font-medium transition-colors"
        >
          Schedule a meeting
          <ArrowUpRight size={14} />
        </a>
      </motion.div>
    </Card>
  );
};

export default ContactSection;
